<template>
    <div>
        <v-select :options="locales"
                  :value="userLanguage"
                  :clearable="false"
                  @input="changeLanguage">
        </v-select>
    </div>
</template>

<script>
    import vSelect from 'vue-select'

    export default {
        name: "ChangeLanguage",
        props: {
            locales: {
                type: Array,
                required: true,
            },
            userLanguage: {
                type: String,
                required: true,
            },
        },
        components: {
            vSelect
        },
        methods: {
            changeLanguage(value) {
                axios.post('/site/change-language', {language:value}).then(res => {
                    window.location.reload();
                });
            }
        },
    }
</script>
